import { useParams } from "react-router-dom";
import { CustomerDetails } from "@/components/dashboard/customers/CustomerDetails";
import { Button } from "@/components/ui/button";
import { DashboardHead } from "@/components/SEO/DashboardHead";
import { ArrowLeft } from "lucide-react";

export function CustomerDetailsPage() {
  const { customerId } = useParams();

  if (!customerId) {
    return <div>Customer ID not found</div>;
  }

  return (
    <div className="space-y-6">
      <DashboardHead pageName="Customer Details" />
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          onClick={() => window.history.back()}
          size="sm"
          className="h-auto gap-1 rounded-full !px-4 !py-2 text-sm font-semibold"
        >
          <ArrowLeft className="h-4 w-4" />
          Back
        </Button>
        <h1 className="text-xl font-medium">Customer Details</h1>
      </div>

      <CustomerDetails customerId={customerId} />
    </div>
  );
}
